// extracted by mini-css-extract-plugin
export default {"PrimerLink":"DirectoryRow-module__PrimerLink__l09PAPe","Box":"DirectoryRow-module__Box__ZfiFrcG","Octicon":"DirectoryRow-module__Octicon__Qs3KMRh"};